import styled from 'styled-components'
import theme from 'theme'

const PlayButtonAsset = (props) => (
  <svg
    width="68"
    height="68"
    viewBox="0 0 68 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden="true"
    {...props}
  >
    <circle cx="34" cy="34" r="34" fill={theme.colors.reds[40]} />
    <path
      d="M24.2857 34.0002V48.5716L51 34.0001L24.2857 19.4287V34.0002Z"
      fill={theme.colors.white}
    />
  </svg>
)

const PlayButton = styled(PlayButtonAsset)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 10;
`

export default PlayButton
